module.exports = __webpack_public_path__ + "img/symbol_1.18942ff2.png";